import React, { Component } from 'react'
import {
    Alert,
    Grid,
    Tabs,
    FormControl,
    TextField,
    FormHelperText,
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LoadingDefault from '../Elements/Loading/LoadingDefault'
import { faSave } from '@fortawesome/pro-duotone-svg-icons/faSave'
import SelectList from '../Elements/SelectList'
import AppDialog from '@/Components/AppDialog/AppDialog'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'
import { StyledVerticalTab } from '@/Components/Elements/StyledComponents/Tabs'
import TabPanel from '@/Components/Elements/TabPanel/TabPanel'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'
class DisplayCustomViewForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            viewName: this.props.item ? this.props.item.viewName : null,
            defDossier: this.props.item
                ? this.props.item.def_dossier_id
                : this.props.defDossierId,
        }

        this.handleChange = this.handleChange.bind(this)
        this.submit = this.submit.bind(this)
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value,
        })
    }

    submit() {
        this.setState({
            submitting: true,
            errors: false,
        })

        let api = this.props.kedo.api()

        let item = {
            viewName: this.state.viewName,
            environment: this.props.kedo.env().getEnvironment().id,
            defDossier: this.state.defDossier,
        }

        if (this.props.item && this.props.item.id) {
            api.patch(
                api.getDisplayCustomViewEndpoint(this.props.item.id),
                item
            )
                .then((successResponse) => this.props.onSuccess())
                .catch((error) =>
                    this.setState({
                        submitting: false,
                        error: api.getErrorFromApiCall(error.response),
                    })
                )
        } else {
            api.post(api.getDisplayCustomViewEndpoint(), item)
                .then((successResponse) => this.props.onSuccess())
                .catch((error) =>
                    this.setState({
                        submitting: false,
                        error: api.getErrorFromApiCall(error.response),
                    })
                )
        }
    }

    renderErrorFeedback(errorMsg) {
        if (!errorMsg) {
            return
        }

        return <FormHelperText>{errorMsg}</FormHelperText>
    }

    render() {
        const kedo = this.props.kedo

        return (
            <AppDialog
                aria-labelledby="display-custom-view"
                open
                maxWidth={'lg'}
                fullWidth
                title={
                    <>
                        {' '}
                        {this.props.item && this.props.item.id
                            ? this.props.kedo.t('Edit')
                            : this.props.kedo.t('Add')}{' '}
                        {this.props.kedo.t('Display custom view').toLowerCase()}
                    </>
                }
                contentProps={{ dividers: true, dense: true }}
                onClose={() => this.props.onClose()}
                headerClose={() => this.props.onClose()}
                actions={
                    <>
                        <StyledButton onClick={this.submit}>
                            {this.state.submitting === true ? (
                                <LoadingDefault size={'sm'} as={'span'} />
                            ) : (
                                <FontAwesomeIcon icon={faSave} />
                            )}
                            &nbsp; {this.props.kedo.t('Save')}
                        </StyledButton>
                        <StyledButton
                            onClick={() => this.props.onClose()}
                            color="secondary"
                        >
                            {this.props.kedo.t('Cancel')}
                        </StyledButton>
                    </>
                }
            >
                <>
                    {this.state.error && this.state.error.generic ? (
                        <Alert severity={'error'}>
                            {this.state.error.generic}
                        </Alert>
                    ) : null}
                    <Grid container>
                        <Grid
                            size={3}
                            sx={{ borderRight: 1, borderColor: 'divider' }}
                        >
                            <Tabs
                                value={'generic'}
                                orientation="vertical"
                                sx={{
                                    '& .MuiTabs-indicator': {
                                        display: 'none',
                                    },
                                }}
                            >
                                <StyledVerticalTab
                                    label={kedo.t('Generic')}
                                    value="generic"
                                />
                            </Tabs>
                        </Grid>
                        <Grid size={9}>
                            <TabPanel value="generic" index="generic">
                                <h3>{kedo.t('Generic')}</h3>
                                <FormControl fullWidth margin="normal">
                                    <FormInputLabel>
                                        {this.props.kedo.t('Name')}
                                    </FormInputLabel>
                                    <TextField
                                        name="viewName"
                                        type="text"
                                        value={this.state.viewName}
                                        onChange={this.handleChange}
                                        size="small"
                                        variant="outlined"
                                        fullWidth
                                    />
                                </FormControl>
                                <FormControl fullWidth margin="normal">
                                    <FormInputLabel>
                                        {this.props.kedo.t('Entity')}
                                    </FormInputLabel>
                                    <SelectList
                                        currentValue={this.state.defDossier}
                                        disableInit={true}
                                        searchName="search"
                                        kedo={kedo}
                                        urlParams={{
                                            environment: this.props.kedo
                                                .env()
                                                .getEnvironment().id,
                                        }}
                                        onDisplayName={(item) =>
                                            this.props.kedo
                                                .env()
                                                .translateItem(
                                                    item,
                                                    'defdossier'
                                                )
                                        }
                                        url={kedo.api().getDefDossierEndpoint()}
                                        onSelect={(item) =>
                                            this.setState({
                                                defDossier: item.id,
                                            })
                                        }
                                    />
                                </FormControl>
                            </TabPanel>
                        </Grid>
                    </Grid>
                </>
            </AppDialog>
        )
    }
}

export default DisplayCustomViewForm
